import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App'
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux'
import { ThemeProvider } from '@mui/styles';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import theme from './theme';

// Import the new consolidated Redux store
import store from './store';

// React 18 createRoot API
const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <Provider store={store}>
        <MuiThemeProvider theme={theme}>
            <ThemeProvider theme={theme}>
                <App />
            </ThemeProvider>
        </MuiThemeProvider>
    </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
